(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-products"] && !Shopify.designMode) return;
  try {
    (function() {
  const FREQ_LABELS = {
    '2-week': 'Every 2 weeks',
    '3-week': 'Every 3 weeks',
    '4-week': 'Every 4 weeks',
    '5-week': 'Every 5 weeks',
    '6-week': 'Every 6 weeks'
  };

  // Cache produse deja fetchuite
  const productCache = {};

  async function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    const r = await fetch(`/products/${handle}.js`);
    const d = await r.json();
    productCache[handle] = d;
    return d;
  }

  async function initEditor(el) {
    const handle = el.dataset.productHandle;
    const currentPlan = parseInt(el.dataset.currentPlan);
    const currentVariant = parseInt(el.dataset.currentVariant);

    const product = await getProduct(handle);

    // Selling plans — din primul variant (identice pentru toate)
    const sellingPlans = product.variants[0].selling_plan_allocations.map(a => ({
      id: a.selling_plan_id,
      groupId: a.selling_plan_group_id
    }));

    // Frecventa — din selling_plan_groups
    const freqSelect = el.querySelector('.cart-sub-editor__frequency');
    freqSelect.innerHTML = '';
    product.selling_plan_groups.forEach(group => {
      const planId = group.selling_plans[0].id;
      const freqValue = group.options.find(o => o.name === 'Order Frequency and Unit')?.values[0] || group.name;
      const label = FREQ_LABELS[freqValue] || group.name;
      const opt = document.createElement('option');
      opt.value = planId;
      opt.textContent = label;
      if (planId === currentPlan) opt.selected = true;
      freqSelect.appendChild(opt);
    });
    freqSelect.disabled = false;

    // Pack size — doar dacă produsul are mai multe variante
    const packRow = el.querySelector('.cart-sub-editor__packsize')?.closest('.cart-sub-editor__row');
    const packSelect = el.querySelector('.cart-sub-editor__packsize');

    if (product.variants.length <= 1 || product.has_only_default_variant) {
      if (packRow) packRow.style.display = 'none';
    } else {
      packSelect.innerHTML = '';
      product.variants.forEach(v => {
        const opt = document.createElement('option');
        opt.value = v.id;
        opt.textContent = v.title;
        if (v.id === currentVariant) opt.selected = true;
        packSelect.appendChild(opt);
      });
      packSelect.disabled = false;
    }

    // Change handlers
    async function updateCart() {
      const newPlan = parseInt(freqSelect.value);
      const newVariant = parseInt(packSelect.value);
      const key = el.dataset.key;

      freqSelect.disabled = true;
      packSelect.disabled = true;

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: 0
          })
        });

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: newVariant,
            quantity: 1,
            selling_plan: newPlan
          })
        });

        // Refresh drawer
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        // Fallback — reload dacă Horizon nu ascultă
        setTimeout(() => window.location.reload(), 300);

      } catch(e) {
        console.error('Cart update failed', e);
        freqSelect.disabled = false;
        packSelect.disabled = false;
      }
    }

    freqSelect.addEventListener('change', updateCart);
    packSelect.addEventListener('change', updateCart);
  }

  function initAllEditors() {
    document.querySelectorAll('.cart-sub-editor:not([data-initialized])').forEach(el => {
      el.setAttribute('data-initialized', '1');
      initEditor(el);
    });
  }

  // Init la load
  initAllEditors();

  // Re-init când drawer-ul se actualizează (Horizon re-renderează cart items)
  document.addEventListener('cart:updated', initAllEditors);
  document.addEventListener('cart-drawer:open', initAllEditors);

  // MutationObserver fallback — dacă Horizon re-renderează DOM-ul
  const observer = new MutationObserver(() => initAllEditors());
  observer.observe(document.body, { childList: true, subtree: true });
})();
  } catch(e) { console.error(e); }
})();

})();
